<template>
  <div class="footer">
    <div class="footer-container main-container">
      <h4 class="footer-title">
        Shopkeeper © 2022
      </h4>
      <h5 class="footer-content">Shopkeeper.gg isn’t endorsed by Riot Games and doesn’t reflect the views or opinions of Riot Games or anyone officially involved in producing or managing League of Legends. League of Legends and Riot Games are trademarks or registered trademarks of Riot Games, Inc. League of Legends © Riot Games, Inc.</h5>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/scss/variables.scss";
.footer {
  background-color: $dark-blue;
  margin-top: -1px;
}
.footer-container {
  padding: 45px 0;
  .footer-title {
    font-family: 'Exo 2';
    font-size: 14px;
    font-weight: 700;
    line-height: 21px;
    letter-spacing: 0.01em;
    text-align: left;
    color: $font-color;
    margin-bottom: 12px;
  }

  .footer-content {
    font-family: 'Exo 2';
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0.01em;
    text-align: left;
    color: $grey-color;

  }
}
@media screen and (max-width: 820px) {
.footer-container {
  padding: 40px;
}
}
@media screen and (max-width: 500px) {
  .footer-title {
    font-size: 10px;
    font-weight: 600;
    line-height: 16px;
  }

  .footer-content {
    font-size: 8px;
    font-weight: 400;
    line-height: 21px;
  }
}
</style>